import React, { ReactElement } from 'react';
import { Content } from './Content';

interface RecoveryRequestPageProps {}

function RecoveryRequestPage({}: RecoveryRequestPageProps): ReactElement {
  return <Content />;
}

export { RecoveryRequestPage };
